import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { ROUTE_FETCH_COMMUNITY_MULTIPLIERS_FOR_WALLET } from "../constants";
import { abfSerializeQueryArgs, rubyBaseQuery } from "./util";
import { CommunityMultiplierReturn } from "../types";

const COMMUNITY_MULTIPLIER_TAG = "CommunityMultiplier";

export const communityMultiplierApi = createApi({
    reducerPath: "communityMultiplierApi",
    tagTypes: [COMMUNITY_MULTIPLIER_TAG],
    baseQuery: rubyBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    endpoints: (builder) => ({
        communityMultipliersForWallet: builder.query<CommunityMultiplierReturn[], string | undefined>({
            providesTags: [COMMUNITY_MULTIPLIER_TAG],
            query() {
                return {
                    url: ROUTE_FETCH_COMMUNITY_MULTIPLIERS_FOR_WALLET,
                    method: "GET"
                };
            }
        })
    })
});

export const { useCommunityMultipliersForWalletQuery } = communityMultiplierApi;

export function useCommunityMultiplierApi() {
    const dispatch = useDispatch();
    return {
        resetCommunityMultipliers: () =>
            dispatch(communityMultiplierApi.util.invalidateTags([COMMUNITY_MULTIPLIER_TAG]))
    };
}
